import { fetchJson } from '../../customers/helpers/helpers';
import { serviceHelper } from '../../../../config/service-helper';
import { trackingContext } from '@jbhi-fi/components/src/Tracking';

export default class ReceiptHelper {
  validateStatus(status) {
    return status >= 200 && status < 500;
  }

  // Get receipt data
  async getReceipt(receiptId) {
    const config = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json;charset=UTF-8',
      },
    };

    return await fetchJson(`${serviceHelper.discoveryServiceUrl}${receiptId}`, config, this.validateStatus);
  }

  // Send verification text message to mobile for receipt access only
  async sendReceiptVerification(receiptId) {
    const config = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json;charset=UTF-8',
      },
    };

    return await fetchJson(`${serviceHelper.discoveryServiceUrl}${receiptId}/SendVerification`, config);
  }

  // Verify receipt access request
  async verifyReceipt(receiptId, code, messageReference) {
    const config = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json;charset=UTF-8',
        'x-verification-code': code,
        'x-verification-reference': messageReference,
      },
    };

    return await fetchJson(`${serviceHelper.discoveryServiceUrl}${receiptId}`, config);
  }

  // Download receipt as PDF
  async downloadReceipt(receiptId, receiptToken) {
    const config = {
      headers: {
        Accept: 'application/pdf',
      },
    };

    if (receiptToken) {
      config.headers['x-token-receipt'] = receiptToken;
    }

    try {
      const response = await fetch(`${serviceHelper.discoveryServiceUrl}${receiptId}/Download`, config);
      if (response.ok) return await response.text();
      return await response.json();
    } catch (error) {
      return { ErrorCode: 'FetchError' };
    }
  }

  redirectToAccount(receiptId, returnUrlParameters = {}) {
    const searchParams = new URLSearchParams({
      gtmCategory: 'eReceipts',
      gtmContext: trackingContext.receipts,
      ...returnUrlParameters,
    });

    window.location.href = `${window.location.origin}/account#/instore/${receiptId}?${searchParams}`;
  }
}
